jPar.loginAndRegistration = jPar.loginAndRegistration || {};
$j.extend(true, jPar.loginAndRegistration, {
	verificationPage: {
		resendCountDownStarted: false,
		resendCountdownInterval: 0,

		init: function init() {
			this.setFormEvents();
			this.setHelpEvents();
			this.countDown();
			this.trackViewScreen();

			try {
				this.loginDelay();
			} catch (e) {
				jPar.util.log.error(e.stack, 'jPar.loginAndRegistration.verificationPage.init: low prio failed');
			}
		},

		countDown: function () {
			if ($j('#verificationTimeoutError').length > 0) {
				$j('#code').attr('readonly', true);
				$j('.codeWrapper').hide();
				const currentMillis = new Date().getTime();
				const blockedUntil = currentMillis + parseInt($j('#verificationTimeoutError').data('countDown'));

				jPar.loginAndRegistration.countdown.start(
					blockedUntil,
					1000,
					(remaining) => {
						$j('.countDown').html(remaining.minutes + ':' + remaining.seconds.toString().padStart(2, '0'));
					},
					() => {
						$j('.countDown').html('0:00');
						location.assign('/login?login_error=verification_code_failed');
					},
				);
			}
		},

		setFormEvents: function () {
			const _this = this;

			$j('#verificationForm').on('keydown keyup', '#code', function (event) {
				_this.hideCursor(event);
				_this.submitCode(event);
				return _this.isWantedCharacter(event);
			});

			$j('#verificationForm').on('change', '#code', function (event) {
				_this.submitCode(event);
			});

			$j('#verificationForm').on('paste', '#code', function (event) {
				_this.removeNotWantedCharacters(event);
			});

			if (document.querySelector('.verificationError')) {
				_this.trackSubmitCodeInvalid();
			}
		},

		setHelpEvents: function () {
			const _this = this;

			$j('.js-openModalDrawer').on('click', function () {
				jPar.wdk.modalbox.show({
					modalboxId: 'helpModal',
				});

				_this.trackOpenHelpModal();
			});

			$j('#resendButton').on('click', function () {
				_this.resendCode();
				_this.trackResendCode();
			});

			$j('#openOscHelpPages').on('click', function () {
				jPar.wdk.modalbox.hide();
				_this.trackClickHelpCenter();
			});

			$j('#cancelButton').on('click', function () {
				jPar.wdk.modalbox.hide();
				_this.trackClickCancelHelpModal();
			});
		},

		isWantedCharacter: function (event) {
			// BUG-16466
			if (this.isNumber(event.key)) {
				return true;
			}

			// other cases
			const charCode = this.getKeyCode(event);
			const backspaceOrDelete = charCode === 8 || charCode === 46;
			const arrows = charCode >= 37 && charCode <= 40;
			const tab = charCode === 9;
			const paste = event.ctrlKey && charCode === 86;
			const functionKeys = charCode >= 112 && charCode <= 123;

			return paste || backspaceOrDelete || arrows || tab || functionKeys;
		},

		getKeyCode: function (event) {
			return event.which ? event.which : event.keyCode;
		},

		isNumber: function (number) {
			return !isNaN(parseFloat(number)) && isFinite(number);
		},

		hideCursor: function (event) {
			if (event.type === 'keydown') {
				if (this.isCodeAlmostComplete()) {
					if (this.isNumber(event.key)) {
						$j(event.target).addClass('cursorHidden');
					} else {
						$j(event.target).removeClass('cursorHidden');
					}
				} else {
					$j(event.target).removeClass('cursorHidden');
				}
			}
		},

		isCodeAlmostComplete: function () {
			const maxLength = parseInt($j('#verificationForm #code').attr('maxLength'));
			const currentLength = $j('#verificationForm #code').val().length;
			return maxLength > 0 && currentLength + 1 >= maxLength;
		},

		isCodeComplete: function () {
			const maxLength = $j('#verificationForm #code').attr('maxLength');
			const currentLength = '' + $j('#verificationForm #code').val().length;
			return maxLength > 0 && currentLength === maxLength;
		},

		removeNotWantedCharacters: function (event) {
			const pastedText = event.originalEvent.clipboardData.getData('text');
			if (pastedText !== '') {
				$j('#code').val(pastedText.replace(/\D+/g, ''));
				event.preventDefault();
				return false;
			}
		},

		submitCode: function (event) {
			if (event.type === 'keyup' && !$j('#verificationForm').hasClass('submitInProgress') && this.isCodeComplete()) {
				$j('#verificationForm').addClass('submitInProgress');
				$j('#code').attr('readonly', true);
				this.trackSubmitCode();
				$j('#verificationForm').trigger('submit');
			}
		},

		resendCode: function () {
			const _this = this;
			$j.ajax({
				type: 'POST',
				url: $j('#verificationForm').data('resendUrl'),
				data: {
					_csrf: jPar.wdk.security.csrf.getToken(),
					j_username: $j('#verificationForm input[name="j_username"]').val(),
				},

				success: function (data) {
					jPar.wdk.modalbox.hide();
					if (data.success) {
						jPar.wdk.modalbox.show({
							modalboxId: 'resendSuccessModal',
						});
						_this.trackResendCodeSuccess();
					} else if (data.blockedDurationInMs) {
						const durationBlocked = data.blockedDurationInMs;
						$j('.resendBlockedCounter').data('countDown', durationBlocked);
						jPar.wdk.modalbox.show({
							modalboxId: 'resendBlockedModal',
						});
						_this.resendCountDown();
					} else {
						jPar.wdk.modalbox.show({
							modalboxId: 'errorModalbox500',
						});
					}
				},
				error: function () {
					jPar.wdk.modalbox.show({
						modalboxId: 'errorModalbox500',
					});
				},
			});
		},

		resendCountDown: function () {
			if ($j('.resendBlockedCounter').data('countDown') !== '' && !this.resendCountDownStarted) {
				this.resendCountDownStarted = true;
				const currentMillis = new Date().getTime();
				const blockedUntil = currentMillis + parseInt($j('.resendBlockedCounter').data('countDown'));

				this.resendCountdownInterval = jPar.loginAndRegistration.countdown.start(
					blockedUntil,
					1000,
					(remaining) => {
						$j('.resendBlockedCounter').html(remaining.minutes + ':' + remaining.seconds.toString().padStart(2, '0'));
					},
					() => {
						this.resendCountDownStarted = false;
						$j('.resendBlockedCounter').html('0:00');
						jPar.loginAndRegistration.countdown.stop(this.resendCountdownInterval);
					},
				);
			}
		},

		loginDelay: function loginDelay() {
			const loginDelay = $j('#loadingText').data('logindelay');

			if (loginDelay !== undefined) {
				window.setTimeout(function () {
					jPar.loginAndRegistration.util.hideLoadingAnimation();
				}, loginDelay);
			}
		},

		trackViewScreen: function () {
			jPar.util.log.bigData({
				category: 'authentication',
				subcategory: 'authentication_screen',
				action: 'screen_view',
			});
		},

		trackSubmitCode: function () {
			jPar.util.log.bigData({
				category: 'authentication',
				subcategory: 'authentication_screen',
				action: 'submit',
			});
		},

		trackSubmitCodeInvalid: function () {
			document.querySelectorAll('.verificationError').forEach(function (element) {
				const errorCode = element.dataset.error;

				jPar.util.log.bigData({
					category: 'authentication',
					subcategory: 'authentication_screen',
					action: 'authentication_invalid',
					targetId: errorCode,
				});
			});
		},

		trackOpenHelpModal: function () {
			jPar.util.log.bigData({
				category: 'authentication',
				subcategory: 'authentication_screen',
				action: 'click',
				targetId: 'link_help',
			});
		},

		trackResendCode: function () {
			jPar.util.log.bigData({
				category: 'authentication',
				subcategory: 'authentication_screen',
				action: 'click',
				targetId: 'button_resend_code',
			});
		},

		trackResendCodeSuccess: function () {
			jPar.util.log.bigData({
				category: 'authentication',
				subcategory: 'authentication_screen',
				action: 'code_sent',
			});
		},

		trackClickHelpCenter: function () {
			jPar.util.log.bigData({
				category: 'authentication',
				subcategory: 'authentication_screen',
				action: 'click',
				targetId: 'button_visit_help_center',
			});
		},

		trackClickCancelHelpModal: function () {
			jPar.util.log.bigData({
				category: 'authentication',
				subcategory: 'authentication_screen',
				action: 'click',
				targetId: 'button_cancel',
			});
		},
	},
});
